import { SETUP_STEP_QUERY, type SetupStepId } from './setupStatus.js';

// WHERE THE KYCKCONNECT PAGES LIVE (redesign Phase 1). PURE: one place builds every link, so a moved page changes one file.

export const KC = {
  overview: '/kyckconnect',
  leads: '/kyckconnect/leads',
  approvals: '/kyckconnect/approvals',
  calls: '/kyckconnect/calls',
  relayLog: '/kyckconnect/lead-relay/log',
  relayRoutes: '/kyckconnect/lead-relay/routes',
  numbers: '/kyckconnect/numbers',
  testLab: '/kyckconnect/test-lab',
  reports: '/kyckconnect/reports',
  botSettings: '/kyckconnect/bot-settings',
} as const;

export type AccountSubTab = 'dashboard' | 'leads' | 'calls' | 'setup';
export const ACCOUNT_SUB_TABS: ReadonlyArray<{ id: AccountSubTab; label: string }> = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'leads', label: 'Leads' },
  { id: 'calls', label: 'Calls' },
  { id: 'setup', label: 'Setup' },
];
export function resolveSubTab(value: string | null | undefined): AccountSubTab {
  return ACCOUNT_SUB_TABS.find((t) => t.id === value)?.id ?? 'dashboard';
}

/** A club's KyckConnect tab, optionally on a sub-tab and an open setup step. */
export function accountKyckConnectHref(accountId: string, sub?: AccountSubTab, step?: SetupStepId): string {
  const q = new URLSearchParams({ tab: 'kyckconnect' });
  if (sub) q.set('sub', sub);
  if (step) q.set('step', SETUP_STEP_QUERY[step]);
  return `/accounts/${encodeURIComponent(accountId)}?${q.toString()}`;
}

/** The "Fix" link for a setup warning: the club's Setup tab, on the step that fixes it. */
export const fixHref = (accountId: string, step: SetupStepId): string => accountKyckConnectHref(accountId, 'setup', step);
